<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-confirm-and-add-other-action="createEntryAndAddOther"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="50%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :saveAndAddOtherButtonEnabled="saveAndAddOtherButtonEnabled"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :withPatrimonies="withPatrimonies"
        :initialDate="initialDate"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
      saveAndAddOtherButtonEnabled: true
    };
  },
  props: {
    withPatrimonies: {
      type: Boolean,
      default: true
    },
    initialDate: {
      type: String,
      default: null
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: NEW_ACTIVITY_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.groundContext.activity;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.$refs.baseNew.closeDialog();
        this.$emit("entry-created", this.entry);
        this.resetForm();
        return true;
      } else {
        return false;
      }
    },
    createEntryAndAddOther: function() {
      if (this.createEntry()){
        this.loadServerEntry();
        this.$refs.baseNew.newDialog = true;
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const NEW_ACTIVITY_QUERY = gql `
  {
    groundContext {
      activity {
        id
        personId
        person {
          id
          name
        }
        durationInHours
        durationInMinutes
        durationText
        startDate
        endDate
        patrimonyId
        patrimony {
          id
          description
        }
        implementId
        implement {
          id
          description
        }
        validations
      }
    }
    accountContext {
      allEmployees {
        id
        name
      }
    }
    accountContext {
      allPatrimoniesExceptImplements {
        id
        description
      }
      allPatrimoniesOfImplementCategory {
        id
        description
      }
    }
  }
`;

</script>

<style scoped></style>
